import React from 'react'
import { Card } from 'react-bootstrap'
import * as s from './EliminatorWinners.scss'
import pluralize from 'pluralize'

const EliminatorWinnerCardFooter = ({ isFinished, week, seasonType, playerCount, ...props }) => (
    <Card.Footer className={s.footer}>
        <div className={s.throughWeek}>
            {isFinished ? 'Contest ended' : 'Through'}
            {' '}
            {seasonType === 'PW' ? 'Postseason' : ''}
            {' '}
            Week {week}
        </div>
        <div className={s.playerCountContainer}>
            <div className={s.playerCount}>{playerCount}</div>
            <div className={s.playerCountText}>{pluralize('player', playerCount, false)}</div>
        </div>
    </Card.Footer>
)

export default EliminatorWinnerCardFooter
